import { MyCompanyUser } from '@/model/user/schema'

export const getFirstChar = (input: string) => {
  return input ? input.substring(0, 1) : ''
}

export const getFileSrc = (extension: string, src: string) => {
  switch (extension) {
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'png':
    case 'bmp':
      return src
    case 'pdf':
      return '/images/icon-pdf.png'
    case 'xls':
    case 'xlsx':
      return '/images/icon-excel.png'
    case 'doc':
    case 'docx':
      return '/images/icon-word.png'
    case 'ppt':
    case 'pptx':
      return '/images/icon-ppt.png'
    default:
      return '/images/icon-file.png'
  }
}

export const extractTimestamps = (text: string) => {
  const matches = text.match(/((\d{1,2}:)?\d{1,2}:\d{2})/g)
  if (!matches) return []
  return matches.map((match) => ({
    time: match,
    timestamp: convertTimeToTimestamp(match)
  }))
}

export const extractMentions = (text: string, users: MyCompanyUser[]) => {
  const getUserIdRegex = /<!user:(\d+)>/g

  // extract mentions
  const matches = text.match(/(<!user:\d+>)/g)
  if (!matches) return []
  return matches.map((match) => {
    const userId = getUserIdRegex.exec(match)
    if (!userId) return null
    const user = users.find((u) => u.id === parseInt(userId[1], 10))
    if (!user) return null
    return {
      raw: match,
      user: user
    }
  })
}

const convertTimeToTimestamp = (time: string) => {
  const parts = time.split(':')
  if (parts.length === 2) {
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10)
  }

  return (
    parseInt(parts[0], 10) * 3600 +
    parseInt(parts[1], 10) * 60 +
    parseInt(parts[2], 10)
  )
}

export interface StringUtils {
  getFirstChar: typeof getFirstChar
  getFileSrc: typeof getFileSrc
  extractTimestamps: typeof extractTimestamps
}
